module.exports = __webpack_public_path__ + "img/ear-hi.e5a5a8d3.png";